// if (!customElements.get('variant-selects')) {

//   /**
//    *  @class
//    *  @function VariantSelects
//    */
//   class VariantSelects extends HTMLElement {
//     constructor() {
//       super();
//       this.sticky = this.dataset.sticky;
//       this.updateUrl = this.dataset.updateUrl === 'true';
//       this.isDisabledFeature = this.dataset.isDisabled;
//       this.addEventListener('change', this.onVariantChange);
//       this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
//         return selector != this;
//       });

//       this.productWrapper = this.closest('.thb-product-detail');
//       this.productSlider = this.productWrapper?.querySelector('.product-images');
//       this.hideVariants = this.dataset.hideVariants === 'true';

//       this.addEventListener('mousedown', (e) => {
//         if (e.target.tagName === 'LABEL') {
//           const scrollY = window.scrollY;
//           requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
//         }
//       });
//     }

//     connectedCallback() {
//       this.updateOptions();
//       this.updateMasterId();
//       this.setDisabled();
//       this.setImageSet();
//     }

//     onVariantChange() {
//       this.updateOptions();
//       this.toggleAddButton(true, '', false);
//       this.updatePickupAvailability();
//       this.removeErrorMessage();
//       this.updateVariantText();
//       this.setDisabled();

//       this.renderVariantInfo();

//       this.updateOther();
//     }

//     updateOptions() {
//       this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
//       this.options = [];
//       this.fieldsets.forEach((fieldset, i) => {
//         if (fieldset.querySelector('select')) {
//           this.options.push(fieldset.querySelector('select').value);
//         } else if (fieldset.querySelectorAll('input').length) {
//           this.options.push(fieldset.querySelector('input:checked').value);
//         }
//       });
//     }
//     updateVariantText() {
//       const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//       fieldsets.forEach((item, i) => {
//         let label = item.querySelector('.form__label__value');
//         if (label) {
//           label.innerHTML = this.options[i];
//         }

//         const accordionSelected = item.closest('.product-option-accordion')?.querySelector('.product-option-accordion__selected');
//         if (accordionSelected) {
//           accordionSelected.innerHTML = this.options[i];
//         }
//       });
//     }
//     updateMasterId() {
//       const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
//       if (!span) return;
//       this.currentVariant = {
//         id: parseInt(span.dataset.variantId, 10) || null,
//         available: span.dataset.available === 'true',
//         featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
//       };
//     }

//     updateOther() {
//       if (this.dataset.updateUrl === 'false') {
//         return;
//       }
//       if (this.other.length) {
//         let fieldsets = this.other[0].querySelectorAll('fieldset'),
//           fieldsets_array = Array.from(fieldsets);
//         this.options.forEach((option, i) => {
//           if (fieldsets_array[i].querySelector('select')) {
//             fieldsets_array[i].querySelector(`select`).value = option;
//           } else if (fieldsets_array[i].querySelectorAll('input').length) {
//             fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
//           }
//         });
//         this.other[0].updateOptions();
//         this.other[0].updateMasterId();
//         this.other[0].updateVariantText();
//         this.other[0].setDisabled();
//       }
//     }
//     updateMedia() {
//       if (!this.currentVariant) return;
//       if (!this.currentVariant.featured_media) return;

//       let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

//       this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
//     }
//     setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
//       let flkty = Flickity.data(productSlider),
//         activeMedia = productSlider.querySelector(mediaId);
//       if (flkty && this.hideVariants) {
//         if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
//           productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
//         }
//         [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
//           el.classList.remove('is-active');
//         });
//         if (this.thumbnails) {
//           if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
//             this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
//           }
//           [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
//             el.classList.remove('is-active');
//           });
//         }

//         activeMedia.classList.add('is-active');
//         activeMedia.classList.add('is-initial-selected');

//         this.setImageSetMedia();

//         if (thumbnails) {
//           let activeThumb = thumbnails.querySelector(thumbId);

//           activeThumb.classList.add('is-active');
//           activeThumb.classList.add('is-initial-selected');
//         }

//         productSlider.reInit(this.imageSetIndex);
//         productSlider.selectCell(mediaId);

//       } else if (flkty) {
//         productSlider.selectCell(mediaId);
//       }

//     }

//     updateURL() {
//       if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//       window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//     }

//     updateShareUrl() {
//       const shareButton = document.getElementById(`Share-${this.dataset.section}`);
//       if (!shareButton) return;
//       shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
//     }

//     updateVariantInput() {
//       const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
//       productForms.forEach((productForm) => {
//         const input = productForm.querySelector('input[name="id"]');
//         input.value = this.currentVariant.id;
//         input.dispatchEvent(new Event('change', {
//           bubbles: true
//         }));
//       });
//     }

//     updatePickupAvailability() {
//       const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

//       if (!pickUpAvailability) return;

//       if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
//         pickUpAvailability.fetchAvailability(this.currentVariant.id);
//       } else {
//         pickUpAvailability.removeAttribute('available');
//         pickUpAvailability.innerHTML = '';
//       }
//     }

//     removeErrorMessage() {
//       const section = this.closest('section');
//       if (!section) return;

//       const productForm = section.querySelector('product-form');
//       if (productForm) productForm.handleErrorMessage();
//     }

//     getSectionsToRender() {
//       return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
//     }

//     getSelectedValueIds() {
//       return this.fieldsets.map((fieldset) => {
//         if (fieldset.querySelector('select')) {
//           return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
//         }
//         return fieldset.querySelector('input:checked')?.dataset.valueId;
//       }).filter(Boolean);
//     }

//     renderVariantInfo() {
//       const ids = this.getSelectedValueIds();
//       if (!ids.length) return;

//       const scrollY = window.scrollY;

//       fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`)
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');

//           // 1. Resolve variant from hidden span
//           const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
//           if (span && parseInt(span.dataset.variantId, 10)) {
//             const fullVariant = this.getVariantData().find((variant) => variant.id === parseInt(span.dataset.variantId, 10));
//             this.currentVariant = fullVariant || {
//               id: parseInt(span.dataset.variantId, 10),
//               available: span.dataset.available === 'true',
//               featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
//             };

//             if (this.currentVariant && span.dataset.featuredMediaId) {
//               this.currentVariant.featured_media = { id: parseInt(span.dataset.featuredMediaId, 10) };
//             }
//           } else {
//             this.currentVariant = null;
//           }

//           // 2. Sync data-available onto current DOM inputs (drives setDisabled)
//           const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
//           if (sourceSelects) {
//             sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
//               const vid = sourceEl.dataset.valueId;
//               const avail = sourceEl.dataset.available;
//               [this, ...this.other].forEach((el) => {
//                 const localEl = el.querySelector(`[data-value-id="${vid}"]`);
//                 if (localEl) localEl.dataset.available = avail;
//               });
//             });
//           }

//           // 3. Update price, inventory, sku sections
//           this.getSectionsToRender().forEach((id) => {
//             const destination = document.getElementById(id);
//             const source = html.getElementById(id);
//             if (source && destination) destination.innerHTML = source.innerHTML;
//             if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
//           });

//           // 3b. Sync button price with current variant price (without badges)
//           const priceSource = html.getElementById(`price-${this.dataset.section}`);
//           if (priceSource) {
//             const tempWrapper = document.createElement('div');
//             tempWrapper.innerHTML = priceSource.innerHTML;
//             tempWrapper.querySelectorAll('.badges').forEach((badgeEl) => badgeEl.remove());
//             const cleanPriceHtml = tempWrapper.innerHTML;

//             document
//               .querySelectorAll(`.single-add-to-cart-button--price[data-section="${this.dataset.section}"]`)
//               .forEach((buttonPrice) => {
//                 buttonPrice.innerHTML = cleanPriceHtml;
//               });
//           }

//           // 4. Apply updated state
//           if (!this.currentVariant) {
//             this.toggleAddButton(true, '', true);
//             this.setUnavailable();
//             window.scrollTo({ top: scrollY, behavior: 'instant' });
//             return;
//           }
//           this.setDisabled();
//           this.updateVariantInput();
//           if (this.updateUrl) this.updateURL();
//           this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
//           this.updateMedia();
//           dispatchCustomEvent('product:variant-change', {
//             sectionId: this.dataset.section,
//             variant: this.currentVariant
//           });
//           dispatchCustomEvent('product:variant-info-updated', {
//             sectionId: this.dataset.section,
//             variant: this.currentVariant
//           });
//           window.scrollTo({ top: scrollY, behavior: 'instant' });
//         });
//     }

//     toggleAddButton(disable = true, text = false, modifyClass = true) {
//       const productForm = document.getElementById(`product-form-${this.dataset.section}`);
//       if (!productForm) return;

//       const productTemplate = productForm.closest('.product-form').getAttribute('template');
//       const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

//       if (!submitButtons) return;

//       submitButtons.forEach((submitButton) => {
//         const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

//         if (!submitButtonText) return;

//         if (disable) {
//           submitButton.setAttribute('disabled', 'disabled');
//           if (text) submitButtonText.dataset.content = text;
//         } else {
//           submitButton.removeAttribute('disabled');
//           submitButton.classList.remove('loading');
//           submitButton.classList.remove('sold-out');

//           if (productTemplate?.includes('pre-order')) {
//             submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
//           } else {
//             submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
//           }
//         }
//       });

//       if (!modifyClass) return;
//     }

//     setUnavailable() {
//       const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
//       const price = document.getElementById(`price-${this.dataset.section}`);
//       const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

//       submitButtons.forEach((submitButton) => {
//         const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
//         if (!submitButton) return;
//         submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
//         submitButton.classList.add('sold-out');
//       });
//       if (price) price.classList.add('visibility-hidden');
//       if (price_fixed) price_fixed.classList.add('visibility-hidden');
//     }

//     setDisabled() {
//       if (this.isDisabledFeature != 'true') return;

//       this.fieldsets.forEach((fieldset) => {
//         if (fieldset.querySelector('select')) {
//           fieldset.querySelectorAll('option').forEach((opt) => {
//             opt.disabled = opt.dataset.available === 'false';
//           });
//         } else {
//           fieldset.querySelectorAll('input').forEach((input) => {
//             input.classList.toggle('is-disabled', input.dataset.available === 'false');
//           });
//         }
//       });
//       return true;
//     }

//     getImageSetName(variant_name) {
//       return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
//     }

//     setImageSet() {
//       if (!this.productSlider) return;

//       let dataSetEl = this.productSlider.querySelector('[data-set-name]');
//       if (dataSetEl) {
//         this.imageSetName = dataSetEl.dataset.setName;
//         this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
//         this.dataset.imageSetIndex = this.imageSetIndex;

//         this.setImageSetMedia();
//       }
//     }
//     setImageSetMedia() {
//       if (!this.imageSetIndex) {
//         return;
//       }

//       const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
//       let setValue = this.getImageSetName(this.options[optionPosition]);
//       let group = this.imageSetName + '_' + setValue;
//       let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
//         selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
//       if (this.hideVariants) {
//         // Product images
//         this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
//           if (thumb.dataset.group && thumb.dataset.group !== group) {
//             thumb.classList.remove('is-active');
//           }
//         });
//         selected_set_images.forEach(thumb => {
//           thumb.classList.toggle('is-active', thumb.dataset.group === group);
//         });

//         // Product thumbnails
//         this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
//           if (thumb.dataset.group && thumb.dataset.group !== group) {
//             thumb.classList.remove('is-active');
//           }
//         });
//         selected_set_thumbs.forEach(thumb => {
//           thumb.classList.toggle('is-active', thumb.dataset.group === group);
//         });
//       }

//     }

//     createAvailableOptionsTree(variant_data, selected_options) {
//       // Reduce variant array into option availability tree
//       return variant_data.reduce((options, variant) => {

//         // Check each option group (e.g. option1, option2, option3) of the variant
//         Object.keys(options).forEach(index => {

//           if (variant[index] === null) return;

//           let entry = options[index].find(option => option.value === variant[index]);

//           if (typeof entry === 'undefined') {
//             // If option has yet to be added to the options tree, add it
//             entry = {
//               value: variant[index],
//               isUnavailable: true
//             };
//             options[index].push(entry);
//           }

//           // Check how many selected option values match a variant
//           const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
//             value,
//             index
//           }) => {
//             return variant[index] === value ? count + 1 : count;
//           }, 0);

//           // Only enable an option if an available variant matches all but one current selected value
//           if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
//             entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
//           }

//           // Make sure if a variant is unavailable, disable currently selected option
//           if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
//             entry.isUnavailable = true;
//           }

//           // First option is always enabled
//           if (index === 'option1') {
//             entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
//           }
//         });

//         return options;
//       }, {
//         option1: [],
//         option2: [],
//         option3: []
//       });
//     }
//     getVariantData() {
//       this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//       return this.variantData;
//     }
//   }
//   customElements.define('variant-selects', VariantSelects);

//   /**
//    *  @class
//    *  @function VariantRadios
//    */
//   class VariantRadios extends VariantSelects {
//     constructor() {
//       super();
//     }

//     updateOptions() {
//       const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//       this.options = fieldsets.map((fieldset) => {
//         return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//       });
//     }
//   }

//   customElements.define('variant-radios', VariantRadios);
// }

// if (!customElements.get('product-slider')) {
//   /**
//    *  @class
//    *  @function ProductSlider
//    */
//   class ProductSlider extends HTMLElement {
//     constructor() {
//       super();

//       this.addEventListener('change', this.setupProductGallery);
//     }
//     connectedCallback() {
//       this.product_container = this.closest('.thb-product-detail');
//       this.quickView = this.closest('#Product-Drawer-Content');
//       this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
//       this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
//       this.progress_bar = this.product_container.querySelector('.flickity-progress--bar'),

//         this.setOptions();
//       // Defer Flickity init to next frame — avoids forced reflow during DOM parsing
//       requestAnimationFrame(() => this.init());
//     }
//     setOptions() {
//       this.hide_variants = this.dataset.hideVariants == 'true';
//       this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
//       this.prev_button = this.querySelector('.flickity-prev');
//       this.next_button = this.querySelector('.flickity-next');
//       this.images = this.querySelectorAll('img');
//       this.options = {
//         wrapAround: true,
//         pageDots: true,
//         contain: true,
//         cellAlign: this.quickView ? 'left' : 'right',
//         adaptiveHeight: !this.quickView,
//         initialIndex: '.is-initial-selected',
//         prevNextButtons: false,
//         rightToLeft: document.dir === 'rtl',
//         fade: false,
//         cellSelector: '.product-images__slide.is-active',
//         on: {
//           ready: () => {
//             this.images.forEach((img) => {
//               img.addEventListener('lazyloaded', () => {
//                 this.flkty.resize();
//               });
//             });
//           },
//           dragStart: () => {
//             this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
//           },
//           dragEnd: () => {
//             this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
//           }
//         }
//       };
//       if (this.quickView) {
//         this.options.wrapAround = false;
//       }
//       if (this.progress_bar) {
//         this.options.on.scroll = (progress) => {
//           progress = Math.max(0, Math.min(1, progress));
//           this.progress_bar.style.width = progress * 100 + '%';
//         };
//       }
//     }
//     init() {
//       this.flkty = new Flickity(this, this.options);

//       this.selectedIndex = this.flkty.selectedIndex;

//       // Setup Events
//       this.setupEvents();

//       // Start Gallery
//       this.setupProductGallery();
//     }
//     reInit(imageSetIndex) {
//       this.flkty.destroy();

//       this.setOptions();

//       this.flkty = new Flickity(this, this.options);

//       // Setup Events
//       this.setupEvents();

//       this.selectedIndex = this.flkty.selectedIndex;
//     }
//     setupEvents() {
//       const _this = this;
//       if (this.prev_button) {
//         let prev = this.prev_button.cloneNode(true);
//         this.prev_button.parentNode.append(prev);
//         this.prev_button.remove();
//         prev.addEventListener('click', (event) => {
//           document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
//         });
//         prev.addEventListener('keyup', (event) => {
//           document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
//           event.preventDefault();
//         });
//       }
//       if (this.next_button) {
//         let next = this.next_button.cloneNode(true);
//         this.next_button.parentNode.append(next);
//         this.next_button.remove();
//         next.addEventListener('click', (event) => {
//           document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
//         });
//         next.addEventListener('keyup', (event) => {
//           document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
//           event.preventDefault();
//         });
//       }
//       this.video_containers.forEach((container) => {
//         container.querySelector('button').addEventListener('click', function () {
//           container.setAttribute('hidden', '');
//         });
//       });
//       this.flkty.on('settle', function (index) {
//         _this.selectedIndex = index;
//       });
//       this.flkty.on('change', (index) => {

//         let previous_slide = this.flkty.cells[_this.selectedIndex].element,
//           previous_media = previous_slide.querySelector('.product-single__media');

//         if (this.thumbnails) {
//           let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
//             active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

//           this.thumbnails.forEach((item, i) => {
//             item.classList.remove('is-initial-selected');
//           });
//           active_thumb.classList.add('is-initial-selected');

//           requestAnimationFrame(() => {
//             if (active_thumb.offsetParent === null) {
//               return;
//             }
//             const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
//               windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
//             active_thumb.parentElement.scrollTo({
//               left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
//               top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
//               behavior: 'smooth'
//             });
//           });
//         }


//         // Stop previous video
//         if (previous_media.classList.contains('product-single__media-external-video')) {
//           if (previous_media.dataset.provider === 'youtube') {
//             previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
//               event: "command",
//               func: "pauseVideo",
//               args: ""
//             }), "*");
//           } else if (previous_media.dataset.provider === 'vimeo') {
//             previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
//               method: "pause"
//             }), "*");
//           }
//           previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
//         } else if (previous_media.classList.contains('product-single__media-native-video')) {
//           previous_media.querySelector('video').pause();
//         }

//       });

//       if (this.thumbnails && !this.thumbnail_container.dataset.init) {
//         setTimeout(() => {
//           let active_thumbs = this.hide_variants ?
//             Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')) :
//             Array.from(this.thumbnails);
//           active_thumbs.forEach((thumbnail, index) => {
//             thumbnail.addEventListener('click', () => {
//               this.thumbnailClick(thumbnail, index);
//             });
//           });
//           this.thumbnail_container.addEventListener('click', (e) => {
//             let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
//             this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
//             if (!this.thumbnail_container.classList.contains('extended')) {
//               this.thumbnail_container.classList.add('extended');
//             } else {
//               if (e.target.nodeName == 'BUTTON') {
//                 this.thumbnail_container.classList.remove('extended');
//               }
//               e.preventDefault();
//             }
//             if (!this.thumbnail_container.classList.contains('extended')) {
//               let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
//               setTimeout(() => {
//                 active_thumb.parentElement.scrollTo({
//                   left: Math.max(active_thumb.offsetLeft, 0),
//                   top: 0,
//                   behavior: 'smooth'
//                 });
//               }, 300);
//             }
//           });
//           this.thumbnail_container.dataset.init = true;
//         });
//       }
//     }
//     thumbnailClick(thumbnail, index) {
//       [].forEach.call(this.thumbnails, function (el) {
//         el.classList.remove('is-initial-selected');
//       });
//       thumbnail.classList.add('is-initial-selected');
//       this.flkty.select(index);
//     }
//     setDraggable(draggable) {
//       this.flkty.options.draggable = draggable;
//       this.flkty.updateDraggable();
//     }
//     selectCell(mediaId) {
//       this.flkty.selectCell(mediaId);
//     }
//     setupProductGallery() {
//       if (!this.querySelectorAll('.product-single__media-zoom').length) {
//         return;
//       }
//       this.setEventListeners();
//     }
//     buildItems() {
//       this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

//       return this.activeImages.map((item) => {
//         let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

//         let activelink = item.querySelector('.product-single__media-zoom');

//         activelink.dataset.index = index;
//         return {
//           src: activelink.getAttribute('href'),
//           msrc: activelink.dataset.msrc,
//           w: activelink.dataset.w,
//           h: activelink.dataset.h
//         };
//       });
//     }
//     setEventListeners() {
//       this.links = this.querySelectorAll('.product-single__media-zoom');
//       this.pswpElement = document.querySelectorAll('.pswp')[0];
//       this.pswpOptions = {
//         maxSpreadZoom: 2,
//         loop: false,
//         allowPanToNext: false,
//         closeOnScroll: false,
//         showHideOpacity: false,
//         arrowKeys: true,
//         history: false,
//         captionEl: false,
//         fullscreenEl: false,
//         zoomEl: false,
//         shareEl: false,
//         counterEl: true,
//         arrowEl: true,
//         preloaderEl: true,
//         getThumbBoundsFn: () => {
//           const thumbnail = this.querySelector('.product-images__slide.is-selected'),
//             pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
//             rect = thumbnail.getBoundingClientRect();
//           return {
//             x: rect.left,
//             y: rect.top + pageYScroll,
//             w: rect.width
//           };
//         }
//       };


//       this.links.forEach((link => {
//         link.addEventListener('click', (e) => this.zoomClick(e, link));
//       }));
//     }
//     zoomClick(e, link) {
//       this.items = this.buildItems();
//       this.pswpOptions.index = parseInt(link.dataset.index, 10);
//       if (typeof PhotoSwipe !== 'undefined') {
//         let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
//         pswp.listen('firstUpdate', function () {
//           pswp.listen('parseVerticalMargin', function (item) {
//             item.vGap = {
//               top: 50,
//               bottom: 50
//             };
//           });
//         });
//         pswp.init();
//       }
//       e.preventDefault();
//     }
//   }
//   customElements.define('product-slider', ProductSlider);
// }

// if (!customElements.get('product-pot-selector')) {
//   class ProductPotSelector extends HTMLElement {
//     constructor() {
//       super();
//       this.onVariantChange = this.onVariantChange.bind(this);
//       this.onVariantInfoUpdated = this.onVariantInfoUpdated.bind(this);
//     }
//     connectedCallback() {
//       this.form = document.getElementById(this.dataset.formId);
//       this.childVariantInput = this.querySelector('[data-pot-child-variant-id]');
//       this.childLabelInput = this.querySelector('[data-pot-child-label]');
//       this.panels = Array.from(this.querySelectorAll('.product-pot-selector__panel'));
//       this.variantSelects = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);

//       this.addEventListener('click', (event) => {
//         const cardButton = event.target.closest('.product-pot-card__button');
//         if (!cardButton) return;

//         this.selectCard(cardButton.closest('.product-pot-card'));
//       });

//       this.addEventListener('change', (event) => {
//         const input = event.target.closest('.product-pot-card input[type="radio"]');
//         if (!input) return;

//         const card = input.closest('.product-pot-card');
//         this.updateCard(card, input);
//         this.selectCard(card);
//       });

//       document.addEventListener('product:variant-change', this.onVariantChange);
//       document.addEventListener('product:variant-info-updated', this.onVariantInfoUpdated);

//       const currentVariantId = this.form?.querySelector('[name="id"]')?.value;
//       this.switchPanel(currentVariantId);
//       this.updateDisplayedPrice();
//     }
//     disconnectedCallback() {
//       document.removeEventListener('product:variant-change', this.onVariantChange);
//       document.removeEventListener('product:variant-info-updated', this.onVariantInfoUpdated);
//     }
//     onVariantChange(event) {
//       if (event.detail?.sectionId !== this.dataset.section) {
//         return;
//       }
//       this.switchPanel(event.detail?.variant?.id);
//       this.updateDisplayedPrice();
//     }
//     onVariantInfoUpdated(event) {
//       if (event.detail?.sectionId !== this.dataset.section) {
//         return;
//       }
//       this.updateDisplayedPrice();
//     }
//     switchPanel(variantId) {
//       let activePanel = null;

//       this.panels.forEach((panel) => {
//         const isActive = panel.dataset.variantId === String(variantId);
//         panel.classList.toggle('is-active', isActive);
//         panel.hidden = !isActive;
//         if (isActive) {
//           activePanel = panel;
//         }
//       });

//       if (!activePanel) {
//         this.hidden = true;
//         this.clearSelection();
//         return;
//       }

//       this.hidden = false;

//       activePanel.querySelectorAll('.product-pot-card').forEach((card) => {
//         const selectedInput = card.querySelector('input[type="radio"]:checked');
//         if (selectedInput) {
//           this.updateCard(card, selectedInput);
//         }
//       });

//       const selectedCard = activePanel.querySelector('.product-pot-card.is-selected');
//       const firstCard = selectedCard || activePanel.querySelector('.product-pot-card');

//       if (firstCard) {
//         this.selectCard(firstCard);
//       } else {
//         this.clearSelection();
//       }
//     }
//     clearSelection() {
//       this.childVariantInput.value = '';
//       this.childLabelInput.value = '';
//       this.querySelectorAll('.product-pot-card').forEach((card) => {
//         card.classList.remove('is-selected');
//       });
//       this.updateDisplayedPrice();
//     }
//     updateCard(card, selectedInput) {
//       const modal = card.dataset.modalId ? document.getElementById(card.dataset.modalId) : null;
//       const variantId = selectedInput?.value || card.dataset.defaultVariantId;
//       const variantTitle = selectedInput?.dataset.variantTitle;
//       const price = selectedInput?.dataset.price;
//       const priceCents = selectedInput?.dataset.priceCents || card.dataset.defaultPriceCents || '0';
//       const compareAtCents = selectedInput?.dataset.compareAtCents || card.dataset.defaultCompareAtCents || '0';
//       const imageSrc = selectedInput?.dataset.imageSrc;
//       const imageSrcset = selectedInput?.dataset.imageSrcset;
//       const imageAlt = selectedInput?.dataset.imageAlt;
//       const displayTitle = variantTitle && variantTitle !== 'Default Title'
//         ? `${card.dataset.productTitle} | ${variantTitle}`
//         : card.dataset.productTitle;

//       card.dataset.selectedVariantId = variantId;
//       card.dataset.selectedPriceCents = priceCents;
//       card.dataset.selectedCompareAtCents = compareAtCents;

//       const titleElement = card.querySelector('[data-pot-title]');
//       if (titleElement) {
//         titleElement.textContent = displayTitle;
//       }

//       const modalTitleElement = modal?.querySelector('[data-pot-modal-title]');
//       if (modalTitleElement) {
//         modalTitleElement.textContent = displayTitle;
//       }

//       if (price) {
//         const priceElement = card.querySelector('[data-pot-price]');
//         if (priceElement) {
//           priceElement.innerHTML = `+ ${price}`;
//         }

//         const modalPriceElement = modal?.querySelector('[data-pot-modal-price]');
//         if (modalPriceElement) {
//           modalPriceElement.innerHTML = `+ ${price}`;
//         }
//       }

//       const compareAtPrice = Number(compareAtCents);
//       const currentPrice = Number(priceCents);
//       const showCompareAt = compareAtPrice > currentPrice;
//       const compareAtLabel = showCompareAt ? this.formatPrice(compareAtPrice) : '';

//       const compareElement = card.querySelector('[data-pot-compare-price]');
//       if (compareElement) {
//         compareElement.innerHTML = compareAtLabel;
//         compareElement.hidden = !showCompareAt;
//       }

//       const modalCompareElement = modal?.querySelector('[data-pot-modal-compare]');
//       if (modalCompareElement) {
//         modalCompareElement.textContent = compareAtLabel;
//         modalCompareElement.hidden = !showCompareAt;
//       }

//       const badgeElement = card.querySelector('[data-pot-badge]');
//       if (badgeElement) {
//         if (showCompareAt) {
//           const savedPercentage = Math.round(((compareAtPrice - currentPrice) * 100) / compareAtPrice);
//           badgeElement.textContent = `Save ${savedPercentage}%`;
//           badgeElement.hidden = false;
//         } else {
//           badgeElement.hidden = true;
//         }
//       }

//       if (imageSrc) {
//         const imageElement = card.querySelector('.product-pot-card__image img');
//         if (imageElement) {
//           imageElement.src = imageSrc;
//           imageElement.setAttribute('src', imageSrc);
//           if (imageSrcset) {
//             imageElement.srcset = imageSrcset;
//             imageElement.setAttribute('srcset', imageSrcset);
//             imageElement.dataset.srcset = imageSrcset;
//           }
//           if (imageAlt) {
//             imageElement.alt = imageAlt;
//           }
//         }

//         const modalImageElement = modal?.querySelector('.product-pot-modal__image img');
//         if (modalImageElement) {
//           modalImageElement.src = imageSrc;
//           modalImageElement.setAttribute('src', imageSrc);
//           if (imageSrcset) {
//             modalImageElement.srcset = imageSrcset;
//             modalImageElement.setAttribute('srcset', imageSrcset);
//             modalImageElement.dataset.srcset = imageSrcset;
//           }
//           if (imageAlt) {
//             modalImageElement.alt = imageAlt;
//           }
//         }
//       }
//     }
//     selectCard(card) {
//       const panel = card.closest('.product-pot-selector__panel');
//       const selectedInput = card.querySelector('input[type="radio"]:checked');
//       const selectedVariantId = selectedInput?.value || card.dataset.selectedVariantId || card.dataset.defaultVariantId;
//       const variantTitle = selectedInput?.dataset.variantTitle;
//       const productTitle = selectedInput?.dataset.productTitle || card.dataset.productTitle;
//       const label = variantTitle && variantTitle !== 'Default Title' ? `${productTitle} - ${variantTitle}` : productTitle;

//       panel.querySelectorAll('.product-pot-card').forEach((item) => {
//         item.classList.toggle('is-selected', item === card);
//       });

//       this.childVariantInput.value = selectedVariantId || '';
//       this.childLabelInput.value = label || '';
//       this.updateDisplayedPrice();
//     }
//     getSelectedPotPrice() {
//       const activePanel = this.querySelector('.product-pot-selector__panel.is-active');
//       const activeCard = activePanel?.querySelector('.product-pot-card.is-selected');
//       const selectedInput = activeCard?.querySelector('input[type="radio"]:checked');

//       return Number(
//         selectedInput?.dataset.priceCents ||
//         activeCard?.dataset.selectedPriceCents ||
//         activeCard?.dataset.defaultPriceCents ||
//         0
//       );
//     }
//     formatPrice(cents) {
//       const format = window.theme.settings.money_with_currency_format || "${{amount}}";

//       return formatMoney(cents, format);
//     }
//     updateDisplayedPrice() {
//       const potPrice = this.getSelectedPotPrice();

//       [
//         document.getElementById(`price-${this.dataset.section}`),
//         document.getElementById(`price-${this.dataset.section}--sticky`)
//       ].forEach((priceContainer) => {
//         if (!priceContainer) return;

//         const priceWrapper = priceContainer.querySelector('.price');
//         if (!priceWrapper?.dataset.price) return;

//         const basePrice = Number(priceWrapper.dataset.price || 0);
//         const baseCompareAtPrice = Number(priceWrapper.dataset.compareAtPrice || 0);
//         const combinedPrice = basePrice + potPrice;
//         const combinedCompareAtPrice = baseCompareAtPrice > basePrice
//           ? baseCompareAtPrice + potPrice
//           : null;
//         const saleAmount = priceContainer.querySelector('ins .amount');
//         const compareAmount = priceContainer.querySelector('del .amount');

//         if (saleAmount) {
//           saleAmount.innerHTML = this.formatPrice(combinedPrice);
//         }

//         if (compareAmount) {
//           if (combinedCompareAtPrice) {
//             compareAmount.innerHTML = this.formatPrice(combinedCompareAtPrice);
//             compareAmount.closest('del')?.removeAttribute('hidden');
//           } else {
//             compareAmount.closest('del')?.setAttribute('hidden', '');
//           }
//         }
//       });

//       document
//         .querySelectorAll(`.single-add-to-cart-button--price[data-section="${this.dataset.section}"] ins .amount`)
//         .forEach((amount) => {
//           const baseAmount = amount.closest('.price')?.dataset.price;
//           if (!baseAmount) return;
//           amount.innerHTML = this.formatPrice(Number(baseAmount) + potPrice);
//         });
//     }
//     getSelection() {
//       if (this.hidden || !this.childVariantInput?.value) {
//         return null;
//       }

//       return {
//         childVariantId: this.childVariantInput.value,
//         childLabel: this.childLabelInput.value
//       };
//     }
//   }

//   customElements.define('product-pot-selector', ProductPotSelector);
// }

// /**
//  *  @class
//  *  @function ProductForm
//  */
// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();
//     }
//     connectedCallback() {
//       this.sticky = this.dataset.sticky;
//       this.form = document.getElementById(`product-form-${this.dataset.section}`);
//       this.form.querySelector('[name=id]').disabled = false;
//       this.potSelector = document.querySelector(`product-pot-selector[data-section="${this.dataset.section}"]`);
//       if (!this.sticky) {
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       }
//       this.cartNotification = document.querySelector('cart-notification');
//       this.body = document.body;

//       this.hideErrors = this.dataset.hideErrors === 'true';
//     }
//     onSubmitHandler(evt) {
//       evt.preventDefault();

//       if (!this.form.reportValidity()) {
//         return;
//       }
//       const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

//       submitButtons.forEach((submitButton) => {
//         if (submitButton.classList.contains('loading')) return;
//         submitButton.setAttribute('aria-disabled', true);
//         submitButton.classList.add('loading');
//       });

//       this.handleErrorMessage();


//       const config = {
//         method: 'POST',
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//           'Accept': 'application/javascript'
//         }
//       };


//       let formData = new FormData(this.form);
//       const potSelection = this.potSelector?.getSelection();
      
//       if (potSelection) {
//         this.submitBundle(this.buildBundlePayload(formData, potSelection), formData, submitButtons);
//         return;
//       }

//       formData.append('sections', this.getSectionsToRender().map((section) => section.section));
//       formData.append('sections_url', window.location.pathname);
//       config.body = formData;

//       fetch(`${theme.routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             dispatchCustomEvent('product:variant-error', {
//               source: 'product-form',
//               productVariantId: formData.get('id'),
//               errors: response.description,
//               message: response.message
//             });
//             if (response.status === 422) {
//               document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                 bubbles: true
//               }));
//             }
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.renderContents(response);

//           dispatchCustomEvent('cart:item-added', {
//             product: response.hasOwnProperty('items') ? response.items[0] : response
//           });
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButtons.forEach((submitButton) => {
//             submitButton.classList.remove('loading');
//             submitButton.removeAttribute('aria-disabled');
//           });
//           if (document.querySelector('.product-add-to-cart-sticky-modal')) {
//             document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
//           }
//         });
//     }

//       submitBundle(payload, formData, submitButtons) {
//       fetch(`${theme.routes.cart_add_url}.js`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify(payload)
//       })
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             dispatchCustomEvent('product:variant-error', {
//               source: 'product-form',
//               productVariantId: formData.get('id'),
//               errors: response.description,
//               message: response.message
//             });
//             if (response.status === 422) {
//               document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                 bubbles: true
//               }));
//             }
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.renderContents(response);

//           dispatchCustomEvent('cart:item-added', {
//             product: response.hasOwnProperty('items') ? response.items[0] : response
//           });
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.resetSubmitButtons(submitButtons);
//         });
//     }

//    resetSubmitButtons(submitButtons) {
//       submitButtons.forEach((submitButton) => {
//         submitButton.classList.remove('loading');
//         submitButton.removeAttribute('aria-disabled');
//       });
//       if (document.querySelector('.product-add-to-cart-sticky-modal')) {
//         document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
//       }
//     }
    
//        buildBundlePayload(formData, potSelection) {
//       const parentItem = this.serializeFormData(formData);
//       const quantity = parentItem.quantity || 1;

//       const childItem = {
//         id: Number(potSelection.childVariantId),
//         quantity,
//         parent_id: parentItem.id
//       };

//       return {
//         items: [parentItem, childItem],
//         sections: this.getSectionsToRender().map((section) => section.section),
//         sections_url: window.location.pathname
//       };
//     }
//     serializeFormData(formData) {
//       const item = {
//         properties: {}
//       };

//       formData.forEach((value, key) => {
//         if (key === 'id') {
//           item.id = Number(value);
//         } else if (key === 'quantity') {
//           item.quantity = Number(value);
//         } else if (key === 'selling_plan' && value) {
//           item.selling_plan = value;
//         } else if (key.startsWith('properties[') && key.endsWith(']') && value !== '') {
//           item.properties[key.slice(11, -1)] = value;
//         }
//       });

//       if (!Object.keys(item.properties).length) {
//         delete item.properties;
//       }

//       return item;
//     }


//     getSectionsToRender() {
//       return [{
//         id: 'Cart',
//         section: 'main-cart',
//         selector: '.thb-cart-form'
//       },
//       {
//         id: 'Cart-Drawer',
//         section: 'cart-drawer',
//         selector: '.cart-drawer'
//       },
//       {
//         id: 'cart-drawer-toggle',
//         section: 'cart-bubble',
//         selector: '.thb-item-count'
//       }];
//     }
//     renderContents(parsedState) {
//       this.getSectionsToRender().forEach((section => {
//         if (!document.getElementById(section.id)) {
//           return;
//         }
//         const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//         elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

//         if (typeof Cart !== 'undefined') {
//           new Cart().renderContents(parsedState);
//         }
//         if (section.id == 'Cart-Drawer') {
//           elementToReplace.removeProductEvent();
//           elementToReplace.notesToggle();
//           elementToReplace.updateFreeShipping();
//         }
//       }));



//       let product_drawer = document.getElementById('Product-Drawer'),
//         search_drawer = document.getElementById('Search-Drawer');

//       if (search_drawer.classList.contains('active')) {
//         search_drawer.classList.remove('active');
//       }
//       if (product_drawer && product_drawer.contains(this)) {
//         product_drawer.classList.remove('active');
//         this.body.classList.remove('open-cc--product');
//         if (document.getElementById('Cart-Drawer')) {
//           this.body.classList.add('open-cc');
//           document.getElementById('Cart-Drawer').classList.add('active');
//         }
//       } else if (document.getElementById('Cart-Drawer')) {
//         this.body.classList.add('open-cc');
//         document.getElementById('Cart-Drawer').classList.add('active');
//         dispatchCustomEvent('cart-drawer:open');
//       }
//     }
//     getSectionInnerHTML(html, selector = '.shopify-section') {
//       return new DOMParser()
//         .parseFromString(html, 'text/html')
//         .querySelector(selector).innerHTML;
//     }
//     handleErrorMessage(errorMessage = false) {
//       if (this.hideErrors) return;
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }

// /**
//  *  @class
//  *  @function ProductAddToCartSticky
//  */
// if (!customElements.get('product-add-to-cart-sticky')) {
//   class ProductAddToCartSticky extends HTMLElement {
//     constructor() {
//       super();
//     }
//     connectedCallback() {
//       this.setupObservers();
//       this.drawer = document.getElementById(this.dataset.target);
//       this.addEventListener('click', this.onClick.bind(this));
//     }
//     onClick() {
//       this.drawer.show();
//     }
//     setupObservers() {
//       let _this = this,
//         observer = new IntersectionObserver(function (entries) {
//           entries.forEach((entry) => {
//             if (entry.target === footer) {
//               if (entry.intersectionRatio > 0) {
//                 _this.classList.remove('sticky--visible');
//               } else if (entry.intersectionRatio == 0 && _this.formPassed) {
//                 _this.classList.add('sticky--visible');
//               }
//             }
//             if (entry.target === form) {
//               let boundingRect = form.getBoundingClientRect();

//               if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
//                 _this.formPassed = true;
//                 _this.classList.add('sticky--visible');
//               } else if (entry.intersectionRatio === 1) {
//                 _this.formPassed = false;
//                 _this.classList.remove('sticky--visible');
//               }
//             }
//           });
//         }, {
//           threshold: [0, 1]
//         }),
//         form = document.getElementById(`product-form-${this.dataset.section}`),
//         footer = document.getElementById('footer');
//       _this.formPassed = false;
//       observer.observe(form);
//     }
//   }

//   customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
// }

// if (typeof addIdToRecentlyViewed !== "undefined") {
//   addIdToRecentlyViewed();
// }


if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();

      // If landing URL points to an unavailable variant, option UI can auto-fallback
      // to an available value. Sync full variant state (id/price/url/add-to-cart) to
      // the currently selected available option set on initial load.
      if (!this.sticky) {
        this.updateOptions();
        this.updateVariantText();
        this.renderVariantInfo();
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      this.renderVariantInfo();

      this.updateOther();
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }

        const accordionSelected = item.closest('.product-option-accordion')?.querySelector('.product-option-accordion__selected');
        if (accordionSelected) {
          accordionSelected.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);
      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    renderVariantInfo() {
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && parseInt(span.dataset.variantId, 10)) {
            const fullVariant = this.getVariantData().find((variant) => variant.id === parseInt(span.dataset.variantId, 10));
            this.currentVariant = fullVariant || {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };

            if (this.currentVariant && span.dataset.featuredMediaId) {
              this.currentVariant.featured_media = { id: parseInt(span.dataset.featuredMediaId, 10) };
            }
          } else {
            this.currentVariant = null;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          // 3b. Sync button price with current variant price (without badges)
          const priceSource = html.getElementById(`price-${this.dataset.section}`);
          if (priceSource) {
            const tempWrapper = document.createElement('div');
            tempWrapper.innerHTML = priceSource.innerHTML;
            tempWrapper.querySelectorAll('.badges').forEach((badgeEl) => badgeEl.remove());
            const cleanPriceHtml = tempWrapper.innerHTML;

            document
              .querySelectorAll(`.single-add-to-cart-button--price[data-section="${this.dataset.section}"]`)
              .forEach((buttonPrice) => {
                buttonPrice.innerHTML = cleanPriceHtml;
              });
          }

          // 4. Apply updated state
          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          dispatchCustomEvent('product:variant-change', {
            sectionId: this.dataset.section,
            variant: this.currentVariant
          });
          dispatchCustomEvent('product:variant-info-updated', {
            sectionId: this.dataset.section,
            variant: this.currentVariant
          });
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.dataset.content = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          const select = fieldset.querySelector('select');
          let hasVisibleSelectedOption = false;

          select.querySelectorAll('option').forEach((opt) => {
            const isUnavailable = opt.dataset.available === 'false';
            opt.disabled = isUnavailable;
            opt.hidden = isUnavailable;
            opt.style.display = isUnavailable ? 'none' : '';
            if (!isUnavailable && opt.selected) hasVisibleSelectedOption = true;
          });

          if (!hasVisibleSelectedOption) {
            const firstAvailableOption = Array.from(select.options).find((opt) => !opt.disabled && !opt.hidden);
            if (firstAvailableOption) {
              select.value = firstAvailableOption.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        } else {
          const radioInputs = fieldset.querySelectorAll('input');
          let hasVisibleCheckedInput = false;

          radioInputs.forEach((input) => {
            const isUnavailable = input.dataset.available === 'false';
            input.classList.toggle('is-disabled', isUnavailable);
            input.disabled = isUnavailable;
            input.hidden = isUnavailable;
            input.style.display = isUnavailable ? 'none' : '';

            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.hidden = isUnavailable;
              label.style.display = isUnavailable ? 'none' : '';
            }

            if (!isUnavailable && input.checked) hasVisibleCheckedInput = true;
          });

          if (!hasVisibleCheckedInput) {
            const firstAvailableInput = Array.from(radioInputs).find((input) => !input.disabled && !input.hidden);
            if (firstAvailableInput) {
              firstAvailableInput.checked = true;
              firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      let setValue = this.getImageSetName(this.options[optionPosition]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.quickView = this.closest('#Product-Drawer-Content');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.progress_bar = this.product_container.querySelector('.flickity-progress--bar'),

        this.setOptions();
      // Defer Flickity init to next frame — avoids forced reflow during DOM parsing
      requestAnimationFrame(() => this.init());
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.images = this.querySelectorAll('img');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        cellAlign: this.quickView ? 'left' : 'right',
        adaptiveHeight: !this.quickView,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        rightToLeft: document.dir === 'rtl',
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        on: {
          ready: () => {
            this.images.forEach((img) => {
              img.addEventListener('lazyloaded', () => {
                this.flkty.resize();
              });
            });
          },
          dragStart: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
          },
          dragEnd: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
          }
        }
      };
      if (this.quickView) {
        this.options.wrapAround = false;
      }
      if (this.progress_bar) {
        this.options.on.scroll = (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progress_bar.style.width = progress * 100 + '%';
        };
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        if (this.thumbnails) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }


        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });

      if (this.thumbnails && !this.thumbnail_container.dataset.init) {
        setTimeout(() => {
          let active_thumbs = this.hide_variants ?
            Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')) :
            Array.from(this.thumbnails);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener('click', (e) => {
            let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
            this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
            if (!this.thumbnail_container.classList.contains('extended')) {
              this.thumbnail_container.classList.add('extended');
            } else {
              if (e.target.nodeName == 'BUTTON') {
                this.thumbnail_container.classList.remove('extended');
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains('extended')) {
              let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: 'smooth'
                });
              }, 300);
            }
          });
          this.thumbnail_container.dataset.init = true;
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-pot-selector')) {
  class ProductPotSelector extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onVariantInfoUpdated = this.onVariantInfoUpdated.bind(this);
      this.onResize = this.onResize.bind(this);
    }
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.childVariantInput = this.querySelector('[data-pot-child-variant-id]');
      this.childLabelInput = this.querySelector('[data-pot-child-label]');
      this.panels = Array.from(this.querySelectorAll('.product-pot-selector__panel'));
      this.variantSelects = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);

      this.panels.forEach((panel) => this.setupPanelSlider(panel));

      this.addEventListener('click', (event) => {
        const cardButton = event.target.closest('.product-pot-card__button');
        if (!cardButton) return;

        this.selectCard(cardButton.closest('.product-pot-card'));
      });

      this.addEventListener('click', (event) => {
        const controlButton = event.target.closest('[data-pot-prev], [data-pot-next]');
        if (!controlButton || controlButton.disabled) return;

        const panel = controlButton.closest('.product-pot-selector__panel');
        this.scrollPanel(panel, controlButton.hasAttribute('data-pot-next') ? 1 : -1);
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('.product-pot-card input[type="radio"]');
        if (!input) return;

        const card = input.closest('.product-pot-card');
        this.updateCard(card, input);
        this.selectCard(card);
      });

      document.addEventListener('product:variant-change', this.onVariantChange);
      document.addEventListener('product:variant-info-updated', this.onVariantInfoUpdated);
      window.addEventListener('resize', this.onResize);

      const currentVariantId = this.form?.querySelector('[name="id"]')?.value;
      this.switchPanel(currentVariantId);
      this.updateDisplayedPrice();
    }
    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
      document.removeEventListener('product:variant-info-updated', this.onVariantInfoUpdated);
      window.removeEventListener('resize', this.onResize);
    }
    onResize() {
      this.refreshAllPanelSliders();
    }
    onVariantChange(event) {
      if (event.detail?.sectionId !== this.dataset.section) {
        return;
      }
      this.switchPanel(event.detail?.variant?.id);
      this.updateDisplayedPrice();
    }
    onVariantInfoUpdated(event) {
      if (event.detail?.sectionId !== this.dataset.section) {
        return;
      }
      this.updateDisplayedPrice();
    }
    switchPanel(variantId) {
      let activePanel = null;

      this.panels.forEach((panel) => {
        const variantIdString = String(variantId || '');
        const panelVariantIds = (panel.dataset.variantIds || panel.dataset.variantId || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);
        const isActive = panelVariantIds.includes(variantIdString);
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        if (isActive) {
          activePanel = panel;
        }
      });

      if (!activePanel) {
        this.hidden = true;
        this.clearSelection();
        return;
      }

      this.hidden = false;
      this.refreshPanelSlider(activePanel, true);

      activePanel.querySelectorAll('.product-pot-card').forEach((card) => {
        const selectedInput = card.querySelector('input[type="radio"]:checked');
        if (selectedInput) {
          this.updateCard(card, selectedInput);
        }
      });

      const selectedCard = activePanel.querySelector('.product-pot-card.is-selected');
      const firstCard = selectedCard || activePanel.querySelector('.product-pot-card');

      if (firstCard) {
        this.selectCard(firstCard);
      } else {
        this.clearSelection();
      }
    }
    clearSelection() {
      this.childVariantInput.value = '';
      this.childLabelInput.value = '';
      this.querySelectorAll('.product-pot-card').forEach((card) => {
        card.classList.remove('is-selected');
      });
      this.refreshAllPanelSliders();
      this.updateDisplayedPrice();
      this.dispatchPotChange();
    }
    setupPanelSlider(panel) {
      const track = panel.querySelector('[data-pot-track]');
      if (!track || track.dataset.sliderReady === 'true') return;

      track.dataset.sliderReady = 'true';
      track.addEventListener('scroll', () => this.updatePanelSliderState(panel));

      // Recalculate after images settle so the thumb width matches real content width.
      panel.querySelectorAll('img').forEach((image) => {
        image.addEventListener('load', () => this.updatePanelSliderState(panel), { once: true });
      });
    }
    refreshAllPanelSliders() {
      this.panels.forEach((panel) => {
        if (!panel.hidden) {
          this.refreshPanelSlider(panel, false);
        }
      });
    }
    refreshPanelSlider(panel, resetPosition = false) {
      const track = panel?.querySelector('[data-pot-track]');
      if (!track) return;

      if (resetPosition) {
        track.scrollTo({ left: 0, behavior: 'auto' });
      }

      requestAnimationFrame(() => this.updatePanelSliderState(panel));
    }
    updatePanelSliderState(panel) {
      const track = panel?.querySelector('[data-pot-track]');
      const controls = panel?.querySelector('[data-pot-controls]');
      const prevButton = panel?.querySelector('[data-pot-prev]');
      const nextButton = panel?.querySelector('[data-pot-next]');
      const progressThumb = panel?.querySelector('[data-pot-progress]');

      if (!track || !controls || !prevButton || !nextButton || !progressThumb) return;

      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const hasOverflow = maxScroll > 2;
      const scrollLeft = Math.min(Math.max(track.scrollLeft, 0), maxScroll);
      const viewportRatio = track.scrollWidth > 0 ? Math.min(track.clientWidth / track.scrollWidth, 1) : 1;
      const scrollProgress = hasOverflow ? scrollLeft / maxScroll : 0;
      const fillWidthPercent = hasOverflow
        ? Math.max((viewportRatio + ((1 - viewportRatio) * scrollProgress)) * 100, 12)
        : 100;

      controls.hidden = !hasOverflow;
      progressThumb.style.width = `${fillWidthPercent}%`;
      progressThumb.style.opacity = hasOverflow ? '1' : '0';

      prevButton.disabled = !hasOverflow || scrollLeft <= 1;
      nextButton.disabled = !hasOverflow || scrollLeft >= maxScroll - 1;
    }
    scrollPanel(panel, direction) {
      const track = panel?.querySelector('[data-pot-track]');
      if (!track) return;

      const amount = Math.max(track.clientWidth * 0.8, 180) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }
    updateCard(card, selectedInput) {
      const modal = card.dataset.modalId ? document.getElementById(card.dataset.modalId) : null;
      const variantId = selectedInput?.value || card.dataset.defaultVariantId;
      const variantTitle = selectedInput?.dataset.variantTitle;
      const price = selectedInput?.dataset.price;
      const priceCents = selectedInput?.dataset.priceCents || card.dataset.defaultPriceCents || '0';
      const compareAtCents = selectedInput?.dataset.compareAtCents || card.dataset.defaultCompareAtCents || '0';
      const imageSrc = selectedInput?.dataset.imageSrc;
      const imageSrcset = selectedInput?.dataset.imageSrcset;
      const imageAlt = selectedInput?.dataset.imageAlt;
      const displayTitle = variantTitle && variantTitle !== 'Default Title'
        ? `${card.dataset.productTitle} | ${variantTitle}`
        : card.dataset.productTitle;

      card.dataset.selectedVariantId = variantId;
      card.dataset.selectedPriceCents = priceCents;
      card.dataset.selectedCompareAtCents = compareAtCents;

      const titleElement = card.querySelector('[data-pot-title]');
      if (titleElement) {
        titleElement.textContent = displayTitle;
      }

      const modalTitleElement = modal?.querySelector('[data-pot-modal-title]');
      if (modalTitleElement) {
        modalTitleElement.textContent = displayTitle;
      }

      if (price) {
        const priceElement = card.querySelector('[data-pot-price]');
        if (priceElement) {
          priceElement.innerHTML = `+ ${price}`;
        }

        const modalPriceElement = modal?.querySelector('[data-pot-modal-price]');
        if (modalPriceElement) {
          modalPriceElement.innerHTML = `+ ${price}`;
        }
      }

      const compareAtPrice = Number(compareAtCents);
      const currentPrice = Number(priceCents);
      const showCompareAt = compareAtPrice > currentPrice;
      const compareAtLabel = showCompareAt ? `+ ${this.formatPrice(compareAtPrice)}` : '';

      const compareElement = card.querySelector('[data-pot-compare-price]');
      if (compareElement) {
        compareElement.innerHTML = compareAtLabel;
        compareElement.hidden = !showCompareAt;
      }

      const modalCompareElement = modal?.querySelector('[data-pot-modal-compare]');
      if (modalCompareElement) {
        modalCompareElement.innerHTML = showCompareAt ? this.formatPrice(compareAtPrice) : '';
        modalCompareElement.hidden = !showCompareAt;
      }

      const badgeElement = card.querySelector('[data-pot-badge]');
      if (badgeElement) {
        if (showCompareAt) {
          const savedPercentage = Math.round(((compareAtPrice - currentPrice) * 100) / compareAtPrice);
          badgeElement.textContent = `Save ${savedPercentage}%`;
          badgeElement.hidden = false;
          badgeElement.style.display = '';
        } else {
          badgeElement.hidden = true;
          badgeElement.style.display = 'none';
          badgeElement.textContent = '';
        }
      }

      if (imageSrc) {
        const imageElement = card.querySelector('.product-pot-card__image img');
        if (imageElement) {
          imageElement.src = imageSrc;
          imageElement.setAttribute('src', imageSrc);
          if (imageSrcset) {
            imageElement.srcset = imageSrcset;
            imageElement.setAttribute('srcset', imageSrcset);
            imageElement.dataset.srcset = imageSrcset;
          }
          if (imageAlt) {
            imageElement.alt = imageAlt;
          }
        }

        const modalImageElement = modal?.querySelector('.product-pot-modal__image img');
        if (modalImageElement) {
          modalImageElement.src = imageSrc;
          modalImageElement.setAttribute('src', imageSrc);
          if (imageSrcset) {
            modalImageElement.srcset = imageSrcset;
            modalImageElement.setAttribute('srcset', imageSrcset);
            modalImageElement.dataset.srcset = imageSrcset;
          }
          if (imageAlt) {
            modalImageElement.alt = imageAlt;
          }
        }
      }
    }
    selectCard(card) {
      const panel = card.closest('.product-pot-selector__panel');
      const selectedInput = card.querySelector('input[type="radio"]:checked');
      const selectedVariantId = selectedInput?.value || card.dataset.selectedVariantId || card.dataset.defaultVariantId;
      const variantTitle = selectedInput?.dataset.variantTitle;
      const productTitle = selectedInput?.dataset.productTitle || card.dataset.productTitle;
      const label = variantTitle && variantTitle !== 'Default Title' ? `${productTitle} - ${variantTitle}` : productTitle;

      panel.querySelectorAll('.product-pot-card').forEach((item) => {
        item.classList.toggle('is-selected', item === card);
      });

      this.childVariantInput.value = selectedVariantId || '';
      this.childLabelInput.value = label || '';
      this.scrollCardIntoTrackView(card, panel);
      this.refreshPanelSlider(panel, false);
      this.updateDisplayedPrice();
      this.dispatchPotChange();
    }
    dispatchPotChange() {
      dispatchCustomEvent('product:pot-change', {
        sectionId: this.dataset.section,
        label: this.childLabelInput?.value || ''
      });
    }
    scrollCardIntoTrackView(card, panel) {
      const track = panel?.querySelector('[data-pot-track]');
      if (!track || !card) return;

      const trackRect = track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const gap = 12;

      if (cardRect.left < trackRect.left + gap) {
        const delta = (trackRect.left + gap) - cardRect.left;
        track.scrollBy({ left: -delta, behavior: 'smooth' });
      } else if (cardRect.right > trackRect.right - gap) {
        const delta = cardRect.right - (trackRect.right - gap);
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }
    getSelectedPotPrice() {
      const activePanel = this.querySelector('.product-pot-selector__panel.is-active');
      const activeCard = activePanel?.querySelector('.product-pot-card.is-selected');
      const selectedInput = activeCard?.querySelector('input[type="radio"]:checked');

      return Number(
        selectedInput?.dataset.priceCents ||
        activeCard?.dataset.selectedPriceCents ||
        activeCard?.dataset.defaultPriceCents ||
        0
      );
    }
    getSelectedPotCompareAtPrice() {
      const activePanel = this.querySelector('.product-pot-selector__panel.is-active');
      const activeCard = activePanel?.querySelector('.product-pot-card.is-selected');
      const selectedInput = activeCard?.querySelector('input[type="radio"]:checked');

      return Number(
        selectedInput?.dataset.compareAtCents ||
        activeCard?.dataset.selectedCompareAtCents ||
        activeCard?.dataset.defaultCompareAtCents ||
        0
      );
    }
    formatPrice(cents) {
      const format = window.theme.settings.money_with_currency_format || "${{amount}}";

      return formatMoney(cents, format);
    }
    updateDisplayedPrice() {
      const potPrice = this.getSelectedPotPrice();
      const potCompareAtPrice = this.getSelectedPotCompareAtPrice();

      [
        document.getElementById(`price-${this.dataset.section}`),
        document.getElementById(`price-${this.dataset.section}--sticky`)
      ].forEach((priceContainer) => {
        if (!priceContainer) return;

        const priceWrapper = priceContainer.querySelector('.price');
        if (!priceWrapper?.dataset.price) return;

        const basePrice = Number(priceWrapper.dataset.price || 0);
        const baseCompareAtPrice = Number(priceWrapper.dataset.compareAtPrice || 0);

        const combinedPrice = basePrice + potPrice;
        const effectiveBaseCompare = baseCompareAtPrice > 0 ? baseCompareAtPrice : basePrice;
        const effectivePotCompare = potCompareAtPrice > 0 ? potCompareAtPrice : potPrice;
        const combinedCompareAtPrice = effectiveBaseCompare + effectivePotCompare;
        const shouldShowCompare = combinedCompareAtPrice > combinedPrice;

        const saleAmount = priceContainer.querySelector('ins .amount');
        let compareWrap = priceContainer.querySelector('del');
        let compareAmount = compareWrap?.querySelector('.amount');

        if (saleAmount) {
          saleAmount.innerHTML = this.formatPrice(combinedPrice);
          saleAmount.classList.toggle('discounted', shouldShowCompare);
        }

        if (shouldShowCompare) {
          if (!compareWrap) {
            compareWrap = document.createElement('del');
            compareAmount = document.createElement('span');
            compareAmount.className = 'amount';
            compareWrap.appendChild(compareAmount);
            saleAmount?.closest('ins')?.insertAdjacentElement('afterend', compareWrap);
          }

          if (compareAmount) {
            compareAmount.innerHTML = this.formatPrice(combinedCompareAtPrice);
          }
          compareWrap.removeAttribute('hidden');
        } else if (compareWrap) {
          compareWrap.setAttribute('hidden', '');
        }
      });

      document
        .querySelectorAll(`.single-add-to-cart-button--price[data-section="${this.dataset.section}"] ins .amount`)
        .forEach((amount) => {
          const baseAmount = amount.closest('.price')?.dataset.price;
          if (!baseAmount) return;
          amount.innerHTML = this.formatPrice(Number(baseAmount) + potPrice);
        });
    }
    getSelection() {
      if (this.hidden || !this.childVariantInput?.value) {
        return null;
      }

      return {
        childVariantId: this.childVariantInput.value,
        childLabel: this.childLabelInput.value
      };
    }
  }

  customElements.define('product-pot-selector', ProductPotSelector);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      this.potSelector = document.querySelector(`product-pot-selector[data-section="${this.dataset.section}"]`);
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);
      const potSelection = this.potSelector?.getSelection();
      
      if (potSelection) {
        this.submitBundle(this.buildBundlePayload(formData, potSelection), formData, submitButtons);
        return;
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          if (document.querySelector('.product-add-to-cart-sticky-modal')) {
            document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
          }
        });
    }

      submitBundle(payload, formData, submitButtons) {
      fetch(`${theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.resetSubmitButtons(submitButtons);
        });
    }

   resetSubmitButtons(submitButtons) {
      submitButtons.forEach((submitButton) => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
      if (document.querySelector('.product-add-to-cart-sticky-modal')) {
        document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
      }
    }
    
       buildBundlePayload(formData, potSelection) {
      const parentItem = this.serializeFormData(formData);
      const quantity = parentItem.quantity || 1;

      const childItem = {
        id: Number(potSelection.childVariantId),
        quantity,
        parent_id: parentItem.id
      };

      return {
        items: [parentItem, childItem],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
    }
    serializeFormData(formData) {
      const item = {
        properties: {}
      };

      formData.forEach((value, key) => {
        if (key === 'id') {
          item.id = Number(value);
        } else if (key === 'quantity') {
          item.quantity = Number(value);
        } else if (key === 'selling_plan' && value) {
          item.selling_plan = value;
        } else if (key.startsWith('properties[') && key.endsWith(']') && value !== '') {
          item.properties[key.slice(11, -1)] = value;
        }
      });

      if (!Object.keys(item.properties).length) {
        delete item.properties;
      }

      return item;
    }


    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        if (section.id == 'Cart-Drawer') {
          elementToReplace.removeProductEvent();
          elementToReplace.notesToggle();
          elementToReplace.updateFreeShipping();
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onPotChange = this.onPotChange.bind(this);
    }
    connectedCallback() {
      this.variantTarget = this.querySelector('[data-sticky-variant]');
      this.potTarget = this.querySelector('[data-sticky-pot]');
      this.setupVisibility();
      this.syncPot();

      document.addEventListener('product:variant-change', this.onVariantChange);
      document.addEventListener('product:variant-info-updated', this.onVariantChange);
      document.addEventListener('product:pot-change', this.onPotChange);
    }
    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
      document.removeEventListener('product:variant-info-updated', this.onVariantChange);
      document.removeEventListener('product:pot-change', this.onPotChange);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    onVariantChange(event) {
      if (event.detail?.sectionId !== this.dataset.section) return;
      const variant = event.detail?.variant;
      if (!this.variantTarget || !variant) return;
      const label = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      this.variantTarget.textContent = label;
      this.variantTarget.hidden = !label;
    }
    onPotChange(event) {
      if (event.detail?.sectionId !== this.dataset.section) return;
      this.setPotLabel(event.detail?.label || '');
    }
    syncPot() {
      const potSelector = document.querySelector(`product-pot-selector[data-section="${this.dataset.section}"]`);
      const selection = potSelector?.getSelection?.();
      this.setPotLabel(selection?.childLabel || '');
    }
    setPotLabel(label) {
      if (!this.potTarget) return;
      this.potTarget.textContent = label;
      this.potTarget.hidden = !label;
    }
    setupVisibility() {
      // The product info column is `position: sticky` on desktop, which makes
      // IntersectionObserver on the form unreliable. Instead we compute the
      // add-to-cart trigger's natural document position (via offsetTop, which
      // is unaffected by sticky painting) and toggle visibility off scroll.
      this.triggerEl =
        document.getElementById('AddToCart') ||
        document.getElementById(`product-form-${this.dataset.section}`);
      this.footerEl = document.getElementById('footer');
      if (!this.triggerEl) return;

      this.onScroll = this.onScroll.bind(this);
      this._ticking = false;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      // Run after layout settles (images/fonts) so positions are accurate.
      this.updateVisibility();
      window.addEventListener('load', () => this.updateVisibility());
    }
    onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this.updateVisibility();
        this._ticking = false;
      });
    }
    getDocumentTop(el) {
      let top = 0;
      while (el) {
        top += el.offsetTop || 0;
        el = el.offsetParent;
      }
      return top;
    }
    updateVisibility() {
      if (!this.triggerEl) return;
      const scrolled = window.scrollY || window.pageYOffset || 0;
      const triggerBottom = this.getDocumentTop(this.triggerEl) + this.triggerEl.offsetHeight;
      const pastTrigger = scrolled > triggerBottom - 10;

      let footerVisible = false;
      if (this.footerEl) {
        footerVisible = this.footerEl.getBoundingClientRect().top < window.innerHeight;
      }

      this.classList.toggle('sticky--visible', pastTrigger && !footerVisible);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}